import { createSlice } from "@reduxjs/toolkit";
import { PartState } from "../models/PartState";

const PartStateInitialState: {
	partState: PartState[];
} = {
	partState: [],
};

export const PartStateReducer = createSlice({
	name: "__",
	initialState: PartStateInitialState,
	reducers: {
		setPartState(state, { payload }) {
			state.partState = payload;
		},
	},
});
